import { editorOrAbovePolicy } from "./common";

/** Ads Analytics リソースのポリシー定義です。 */
export const ADS_POLICIES = {
  /** プロジェクトの作成・編集可否を判定します。 */
  "ads-project:edit": editorOrAbovePolicy,
  /** ビューの操作可否を判定します。 */
  "ads-view:edit": editorOrAbovePolicy,
  /** Ads Analytics のデータソース設定操作の可否を判定します。 */
  "ads-sources:edit": editorOrAbovePolicy,
} as const;
